import { Center, Spinner } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

const DelayedFallback = ({ delay = 300 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timeout); // limpeza
  }, [delay]);

  if (!show) return null;

  return (
    <Center h="100vh">
      <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
    </Center>
  );
};

export default DelayedFallback;
